import { combineReducers } from "redux";

import vehicles from "./vehicles";

const rootReducer = combineReducers({
  vehicles
})

export default rootReducer;